import { printBalances } from '@guuru/money-common';

const Balance = function ({ balances = [] }) {
  return printBalances(balances);
};

export default Balance;
